export DayChooser from './DayChooser';
export AbstractMenuComponent from './AbstractMenuComponent';
export OnLoadingContentView from './OnLoadingContentView';
export RoundButton from './RoundButton';
export Footer from './footer';

// keep old path for the moment to ensure compatibility
export NoPermissionIcon from './security/NoPermissionIcon';

export AbstractComponent from './AbstractComponent';



// WEBPACK FOOTER //
// ./scripts/components/index.js